import { createContext, useContext } from 'react'
import { SIPMasterPayload, OrderOtpState, InvestPaymentMethodType } from '../../types/mf-execution.types'
import { OTPVerificationState, OTPVerificationHandlers } from '../../types/otp.types'
import { CalendarSelection } from '../../types/calendar.types'
import { InstalledUpiApp } from '../../utils/installedUpiIntents'
import { AmountAdjustmentReason } from '../../utils/mf-execution/paymentAmount'

interface SIPContextType {
  sipMasterPayload: SIPMasterPayload
  handleSIPMasterPayload: (payload: SIPMasterPayload) => void
  isSIPOTPVerified: boolean
  handleSIPOTPVerification: (otp: string) => void
  otpVerificationState: OTPVerificationState
  otpVerificationHandlers: OTPVerificationHandlers
  paymentMethods: InvestPaymentMethodType[] | undefined
  bankAccountDetails: InvestPaymentMethodType[] | undefined
  defaultPaymentMethodDetails: InvestPaymentMethodType | null | undefined
  upiIntentMaximumAllowedAmount: number
  selectedPaymentMethod: InvestPaymentMethodType | null
  handlePaymentMethodChange: (paymentMethod: InvestPaymentMethodType | null) => void
  amount: number
  /** Amount the screen opened with. Null when the field opened empty. */
  initialShownAmount: number | null
  handleAmountChange: (amount: number) => void
  fromAdvisory: boolean
  fromApp: boolean
  amountAdjustmentReason: AmountAdjustmentReason
  clearAmountAdjustmentReason: () => void
  handleOTPTrigger: (payload: SIPMasterPayload) => void
  calendarSelection: CalendarSelection
  handleCalendarSelection: (calendarSelection: CalendarSelection) => void
  handleRefetchPaymentMethods: () => void
  otpState: OrderOtpState | null
  installedUpiApps: InstalledUpiApp[] | null
  requestUpiIntents: () => void
}

export const SIPContext = createContext<SIPContextType | undefined>(undefined)

export const useSIPContext = () => {
  const context = useContext(SIPContext)
  if (!context) {
    throw new Error('useSIPContext must be used within a SIPProvider')
  }
  return context
}
